/**
 * internalInboxFilter — esconde a(s) inbox(es) interna(s) ("Equipe Modeloja") de
 * uma lista de inboxes (usado na lista de Canais da sidebar).
 *
 * Coage os dois lados para Number, então um id jsonb string ("6") casa com um
 * Integer 6 — a MESMA coerção que o backend faz em
 * CwCustom::Crm::AccountSetting.internal_inbox?. Sem essa coerção a inbox interna
 * "vazaria" para a lista quando os ids viessem como string do banco.
 *
 * Pura e total: devolve um array NOVO, nunca muta, tolera null/undefined nos dois
 * argumentos (fail-open: sem ids para esconder, devolve a lista inteira).
 *
 * @param {Array<{id: number|string}>} inboxes
 * @param {Array<number|string>} internalInboxIds
 * @returns {Array}
 */
export function rejectInternalInboxes(inboxes, internalInboxIds) {
  const list = Array.isArray(inboxes) ? inboxes : [];
  const hidden = new Set(
    (Array.isArray(internalInboxIds) ? internalInboxIds : []).map(Number)
  );
  if (hidden.size === 0) return list.slice();
  return list.filter(inbox => !hidden.has(Number(inbox?.id)));
}
